export const galleryCategories = [
  { id: "all", name: { nl: "Alle Media", en: "All Media", tr: "Tüm Medyalar" } },
  { id: "photo", name: { nl: "Foto's 📸", en: "Photos 📸", tr: "Fotoğraflar 📸" } },
  { id: "video", name: { nl: "Video's 🎥", en: "Videos 🎥", tr: "Videolar 🎥" } },
  { id: "fade", name: { nl: "Skin Fade & Opscheer", en: "Skin Fade & Taper", tr: "Skin Fade & Geçişler" } },
  { id: "hairpiece", name: { nl: "Haarwerk & Protez", en: "Hair Systems", tr: "Protez Saç" } },
  { id: "beard", name: { nl: "Baard & Lijnen", en: "Beard Design", tr: "Sakal & Çizgi" } },
  { id: "classic", name: { nl: "Klassiek & Salon", en: "Classic & Salon", tr: "Klasik & Salon" } }
];

export const galleryItems = [
  {
    id: "g-vid-1",
    type: "video",
    title: { nl: "Master Skin Fade & Textuur Styling", en: "Master Skin Fade & Textured Styling", tr: "Master Skin Fade & Dokulu Şekillendirme" },
    category: "fade",
    tag: "Video 4K",
    duration: "0:45",
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=800&auto=format&fit=crop&q=80",
    videoUrl: "https://assets.mixkit.co/videos/preview/mixkit-barber-cutting-the-hair-of-a-man-with-scissors-41221-large.mp4"
  },
  {
    id: "g1",
    type: "image",
    title: { nl: "Mid Skin Fade & Crop", en: "Mid Skin Fade & Crop", tr: "Mid Skin Fade & Dokulu Kesim" },
    category: "fade",
    tag: "Trending 2026",
    image: "/images/hair_system_result_3_1788255394814.webp"
  },
  {
    id: "g-vid-2",
    type: "video",
    title: { nl: "Niet-Chirurgisch Haarwerk Transformatie", en: "Non-Surgical Hair System Transformation", tr: "Ameliyatsız Protez Saç Dönüşümü" },
    category: "hairpiece",
    tag: "Transformatie",
    duration: "1:15",
    image: "/images/hair_system_result_4_1788255415949.webp",
    videoUrl: "https://assets.mixkit.co/videos/preview/mixkit-stylist-washing-the-hair-of-a-client-in-a-salon-43750-large.mp4"
  },
  {
    id: "g2",
    type: "image",
    title: { nl: "Traditionele Baard & Contour", en: "Traditional Beard & Edge", tr: "Geleneksel Sakal & Çizgi" },
    category: "beard",
    tag: "Hot Towel",
    image: "https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=800&auto=format&fit=crop&q=80"
  },
  {
    id: "g3",
    type: "image",
    title: { nl: "Classic Taper & Schaarwerk", en: "Classic Taper & Scissor", tr: "Klasik Taper & Makas Kesimi" },
    category: "classic",
    tag: "Signature",
    image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=800&auto=format&fit=crop&q=80"
  },
  {
    id: "g-vid-3",
    type: "video",
    title: { nl: "Traditionele Baardverzorging & Warme Handdoek", en: "Traditional Hot Towel Beard Ritual", tr: "Geleneksel Sıcak Havlu Sakal Ritüeli" },
    category: "beard",
    tag: "Ritueel",
    duration: "0:50",
    image: "https://images.unsplash.com/photo-1517832606299-7ae9b720a186?w=800&auto=format&fit=crop&q=80",
    videoUrl: "https://assets.mixkit.co/videos/preview/mixkit-barber-shaving-a-mans-beard-with-a-straight-razor-41223-large.mp4"
  },
  {
    id: "g4",
    type: "image",
    title: { nl: "Haarstuk Plaatsing & Blending", en: "Hair System Cut-In & Blend", tr: "Protez Saç Birleştirme Kesimi" },
    category: "hairpiece",
    tag: "Haarwerk",
    image: "/images/hair_system_result_2_1788255376979.webp"
  },
  {
    id: "g5",
    type: "image",
    title: { nl: "High Fade & Pompadour", en: "High Fade & Pompadour", tr: "High Fade & Pompadour" },
    category: "fade",
    tag: "Modern",
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=800&auto=format&fit=crop&q=80"
  },
  {
    id: "g6",
    type: "image",
    title: { nl: "Natuurlijk Haarwerk Resultaat", en: "Natural Hair System Result", tr: "Doğal Protez Saç Sonucu" },
    category: "hairpiece",
    tag: "100% Human Hair",
    image: "/images/hair_system_result_4_1788255415949.webp"
  },
  {
    id: "g7",
    type: "image",
    title: { nl: "Volledige Baardverzorging & Olie", en: "Full Beard Care & Oil", tr: "Dolgun Sakal Bakımı & Yağ" },
    category: "beard",
    tag: "Beard Care",
    image: "https://images.unsplash.com/photo-1517832606299-7ae9b720a186?w=800&auto=format&fit=crop&q=80"
  },
  {
    id: "g8",
    type: "image",
    title: { nl: "Sfeer in Aura Hair Rotterdam", en: "Aura Hair Rotterdam Salon", tr: "Aura Hair Rotterdam Atmosfer" },
    category: "classic",
    tag: "Rotterdam",
    image: "/images/salon_interior_hd.webp"
  }
];
